import React from 'react'
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteIconOutlined from '@material-ui/icons/DeleteOutline';
import Tr from 'translations/Translations';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconDeleteButton(
    {
        tooltip = Tr('delete'),
        outlined = false,
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={outlined ? DeleteIconOutlined : DeleteIcon}
        {...props}
    />
}

WorkableIconDeleteButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconDeleteButton;